import React, { FunctionComponent, memo, useState } from 'react';
import Typography, { TypographyProps } from '@material-ui/core/Typography';
import Tooltip from '../../../../gqlCommon/components/presentation/tooltip/Tooltip';
import { Disclaimer } from '../../../../gqlCommon/graphql/fragments/__generated__/Disclaimer';
import DisclaimerItem from '../../../../gqlCommon/components/disclaimers/DisclaimerItem';
import Translation from '../../../../gqlCommon/components/translation/Translation';

export interface IReferenceNumberProps {
  value: number | string;
  disclaimer?: Disclaimer;
}
const ReferenceNumber: FunctionComponent<IReferenceNumberProps & TypographyProps & { component?: any }> = memo(
  ({ value, disclaimer, ...rest }) => {
    const [isTooltipOpen, setIsTooltipOpen] = useState<boolean>(false);

    const handleClick = () => {
      if (disclaimer) {
        setIsTooltipOpen(true);
      }
    };

    const translatedValue = typeof value === 'string' ? <Translation id={value} /> : value;

    return (
      <>
        <Typography {...rest} onClick={handleClick}>
          {translatedValue}
        </Typography>
        {!!disclaimer && (
          <Tooltip
            isOpen={isTooltipOpen}
            onClose={() => setIsTooltipOpen(false)}
            id="rn"
            text={<DisclaimerItem disclaimer={disclaimer} />}
          />
        )}
      </>
    );
  },
);

export default ReferenceNumber;
